import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class Layout {
	constructor() {
		this.nav = $('.nav');
		this.navToggle = $('.js-nav-toggle');
		this.navToggleChildren = $('.js-nav-toggle-children');
	}

	init() {
		this.bindEvents();
	}

	bindEvents() {
		this.navToggle.on('click', e => { e.stopPropagation(); this.toggleNav(e); });
		this.navToggleChildren.on('click', e => { this.mobileNavItem(e); });
	}

	toggleNav(e) {
		const target = $(e.currentTarget);

		target.toggleClass('open');

		$('.nav').slideToggle();
		$('body').toggleClass('nav-open');
	}

	// clicking on items in mobile nav
	mobileNavItem(e) {
		if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
			e.preventDefault();

			const target = $(e.currentTarget);
			const parent = target.closest('li');

			$(parent).find('> ul').slideToggle();
			$(parent).toggleClass('open');
		}
	}
}

export default Layout;